import { FC, useState } from 'react';
import SidePanel from 'components/SidePanel/SidePanel';
import { OTHER_GROUP_NAME, PRACTICE_FILTER_OPTIONS } from 'utils/constants';
import Item from './Item/Item';
import { IClinicResponse } from 'hooks/useAllClinic';
import CreatePracticeModal from '../CreatePracticeModal/CreatePracticeModal';
import { groupBy, orderBy } from 'lodash';
import ExpandWrapper from 'components/ExpandWrapper/ExpandWrapper';
import { ReactComponent as TriangleIcon } from 'assets/icons/triangle.svg';
interface PracticePanelProps {
  practices: IClinicResponse[];
  setSelectedPractice: React.Dispatch<
    React.SetStateAction<IClinicResponse | null>
  >;
  selectedPractice: IClinicResponse;
  totalPracticeByStatus: {
    active: number;
    inactive: number;
    all: number;
  } | null;
  isGroupAdminView?: boolean;
}

const { ACTIVE, ALL } = PRACTICE_FILTER_OPTIONS;

const PracticePanel: FC<PracticePanelProps> = ({
  practices,
  selectedPractice,
  setSelectedPractice,
  totalPracticeByStatus,
  isGroupAdminView,
}) => {
  const [selectedFilter, setSelectedFilter] = useState(ACTIVE);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isModalOpen, setisModalOpen] = useState(false);

  const getFilterPractice = (filterOption: string) => {
    const filterPractice =
      filterOption !== ALL
        ? practices.filter((practice) => {
            if (filterOption === ACTIVE) {
              return practice.isActive;
            }
            return !practice.isActive;
          })
        : practices;
    return filterPractice;
  };

  const filterPractice = getFilterPractice(selectedFilter);

  const orderByGroupName = orderBy(
    filterPractice,
    [
      (item) => item.clinicGroup?.name === OTHER_GROUP_NAME,
      (item) => item.clinicGroup?.name,
    ],
    ['asc', 'asc']
  );

  const isOptionDropdownDisabled = (option: string) => {
    return (
      totalPracticeByStatus?.[
        option.toLowerCase() as keyof typeof totalPracticeByStatus
      ] === 0
    );
  };

  const onFilterOptionClicked = (option: string) => {
    const firstPractice = getFilterPractice(option)[0];

    setSelectedFilter(option);
    setSelectedPractice(firstPractice);
  };

  const groupByClinicGroupName = groupBy(
    orderByGroupName,
    (item) => item.clinicGroup?.name
  );

  return (
    <>
      {isModalOpen && (
        <CreatePracticeModal
          onClose={() => setisModalOpen(false)}
          setSelectedPractice={setSelectedPractice}
        />
      )}
      <SidePanel
        title={'Practices'}
        isCollapsed={isCollapsed}
        onCollapsedIconClicked={() => setIsCollapsed(!isCollapsed)}
        selectedFilter={selectedFilter}
        onFilterOptionClicked={onFilterOptionClicked}
        isOptionDropdownDisabled={isOptionDropdownDisabled}
        numberOfFilters={filterPractice.length}
        options={PRACTICE_FILTER_OPTIONS}
        onAddClick={() => setisModalOpen(true)}
        isAddButtonHidden={isGroupAdminView}
      >
        {Object.entries(groupByClinicGroupName).map(
          ([clinicGroupName, practices]) => (
            <ExpandWrapper
              iconClassName="hidden"
              className="w-full first-child:w-full "
              header={({ isExpanded }) => (
                <div
                  className={`text-16 flex items-center font-bold w-full h-4.5 text-mid-grey px-1 gap-x-0.5`}
                >
                  <TriangleIcon
                    className={`${
                      isExpanded ? '' : '-rotate-90'
                    } transition-transform shrink-0 all-child:fill-mid-grey`}
                  />
                  <span className="truncate max-w-[95%]">
                    {clinicGroupName.toUpperCase()}
                  </span>
                </div>
              )}
            >
              {practices.map((practice) => (
                <Item
                  key={practice.id}
                  selectedPracticeId={selectedPractice.id}
                  practice={practice}
                  isCollapsed={isCollapsed}
                  onClick={() => setSelectedPractice(practice)}
                />
              ))}
            </ExpandWrapper>
          )
        )}
      </SidePanel>
    </>
  );
};

export default PracticePanel;
